<div class="modal fade" id="modalAdmin" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">

    <div class="modal-dialog cascading-modal modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header darken-3 justify-content-center text-center text-white contactmodal">
                <h4 class="text-uppercase font-weight-bold text-center mx-5 pt-2">
                    <i class="fa fa-pencil-alt px-2"></i>Admin Settings
                </h4>
                <button type="button" class="close waves-effect waves-light " data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <mdb-card-body>
                    <div class="container ">
                        <div class="card-block mt-4 mb-3 ">
                            <div class="row  mb-2 ">
                                <div class="col-lg-2 col-md-4 "></div>
                                <div class="col-lg-3 col-md-4 wow d-flex align-items-stretch icon-box" data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="200" data-mdb-animation-on-scroll="repeat">
                                    <a data-toggle="modal" data-target="#NotificationModal" (click)="LoadNotification('notification');" id="loadNotification" data-backdrop="false">
                                    <div
                                                                      class="card text-center rounded-top 
                                              rounded-lg border border-secondary mb-2 waves-effect z-depth-5 view overlay zoom  ">
                                                                      <div class="card-body">
                                                                      <i class="fas fa-bell iconColor"></i>
                                                                      </div>
                                                                      <div
                                                                            class="mask flex-center rgba-purple-slight">
                                                                           
                                                                      </div>
                                                                      <div class="card-footer">
                                                                            <h6
                                                                                  class="font-weight-light  wow fadeInUp  text-uppercase">
                                                                                 Notification</h6>
                                                                      </div>
                                                                </div>
                                    </a>
                                </div>

                                <div class="col-lg-2 col-md-4 "></div>

                            </div>




                        </div>
                    </div>


                </mdb-card-body>




            </div>



        </div>

    </div>

</div>